var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"d-none d-lg-block",style:({ height: _vm.height })}),_c('div',{staticClass:"d-lg-none",style:({ height: _vm.mobileHeight })})])}
var staticRenderFns = []

export { render, staticRenderFns }